import { isEmpty } from 'lodash';

export const getDropoffAddress = (shipment, selectedAssignment) => {
  if (
    isEmpty(selectedAssignment?.customer_profiles)
    // || [DROPOFF_SUCCEEDED].includes(shipment.status)
  )
    return {
      dropoff_address: shipment.dropoff_address,
    };

  const findCustomerProfile = selectedAssignment.customer_profiles?.find((p) => p.id === shipment?.customer_profile_id);

  if (isEmpty(findCustomerProfile?.corrected_address))
    return {
      dropoff_address: shipment.dropoff_address,
    };

  return {
    dropoff_address: {
      ...shipment.dropoff_address,
      ...findCustomerProfile.corrected_address,
    },
  };
};
